<div class="project-consult-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Registro de projetos e emissão de créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Projeto de Crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Consulta</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Consulta de Projetos</h1>
  </div>

  <section class="consult-content" aria-label="Consulta de projetos">
    <div class="consult-toolbar">
      <div class="consult-filters">
        <div class="consult-filters__field consult-filters__field--search">
          <b3-input-search
            [(ngModel)]="searchTerm"
            inputId="searchTerm"
            label="Nome do projeto"
            background="grey"
            placeholder="Pesquisar pelo nome do projeto"
            searchAriaLabel="Buscar projetos pelo nome"
            closeAriaLabel="Limpar busca de projetos"
            (b3-search)="onFilterTable()"
            (b3-clear)="onFilterTable()">
          </b3-input-search>
        </div>

        <div class="consult-filters__field consult-filters__field--status">
          <b3-input-select
            [(ngModel)]="searchStatus"
            inputId="searchStatus"
            label="Status"
            placeholder="Selecione o status"
            background="grey"
            maxHeight="280px"
            [options]="selectedStatus"
            (b3-change)="onFilterTable()">
            <b3-input-select-option
              *ngFor="let item of selectedStatus; let i = index"
              [attr.value]="item.inputId"
              [attr.index]="i"
              [id]="'searchStatus-option-' + item.inputId">
              {{ item.label }}
            </b3-input-select-option>
          </b3-input-select>
        </div>
      </div>

      <div class="consult-toolbar__action">
        <span class="consult-toolbar__label-spacer" aria-hidden="true"></span>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          size="lg"
          class="consult-toolbar__new-btn"
          (b3-click)="navigateToProjectRegister()">
          <b3-icon name="add"></b3-icon>
          Novo Projeto
        </b3-button>
      </div>
    </div>

    <div class="consult-table-section">
      <p class="consult-table-summary" aria-live="polite">{{ projectsFoundLabel }}</p>

      <div class="consult-table-shell">
        <b3-table
          size="lg"
          background="white"
          aria-label="Lista de projetos"
          [attr.aria-rowcount]="totalItens"
          aria-colcount="4"
          (b3-sort)="onTableSort($event)">
          <b3-table-rowgroup group="header">
            <b3-table-row>
              <b3-table-cell-header label="Nome do projeto">
              </b3-table-cell-header>
              <b3-table-cell-header
                label="Data de envio"
                sortable
                sort-aria-label="Ordenar por data de envio">
              </b3-table-cell-header>
              <b3-table-cell-header
                label="Status"
                sortable
                sort-aria-label="Ordenar por status">
              </b3-table-cell-header>
              <b3-table-cell-header label="Ações"></b3-table-cell-header>
            </b3-table-row>
          </b3-table-rowgroup>

          <b3-table-rowgroup group="body">
            <b3-table-row
              *ngFor="let project of itens; trackBy: trackByProjectId"
              [id]="'project-row-' + project.projectId">
              <b3-table-cell variant="text" [label]="project.projectName || '-'"></b3-table-cell>
              <b3-table-cell variant="text" [label]="project.insertDate || '-'"></b3-table-cell>
              <b3-table-cell variant="tag">
                <b3-tag
                  size="sm"
                  variant="filled"
                  [icon]="getStatusIcon(project.status)"
                  [tone]="getStatusTone(project.status)"
                  [label]="getStatusLabel(project.status)">
                </b3-tag>
              </b3-table-cell>
              <b3-table-cell variant="slot">
                <div class="consult-table-actions">
                  <b3-button
                    type="button"
                    variant="ghost"
                    tone="default"
                    [attr.aria-label]="getProjectActionLabel(project)"
                    (b3-click)="onProjectAction(project)">
                    <b3-icon [name]="getProjectActionIcon(project)" size="md"></b3-icon>
                  </b3-button>
                </div>
              </b3-table-cell>
            </b3-table-row>
          </b3-table-rowgroup>
        </b3-table>
      </div>

      <div class="consult-table-pagination" *ngIf="totalPages > 1">
        <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
        <b3-pagination
          aria-label="Paginação de projetos"
          variant="numbers"
          navigation="icon"
          overflow
          [attr.total]="totalPages"
          [attr.current]="pagination.page ?? 1"
          (b3-change)="onPaginationChange($event)">
        </b3-pagination>
      </div>
    </div>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-project-consult-details-drawer
  [open]="isDetailsDrawerOpen"
  [projectId]="selectedProjectId"
  (openChange)="onDetailsDrawerOpenChange($event)"
  (projectUpdated)="onProjectUpdatedInDrawer()"
  (rmConfirmed)="onRmConfirmed($event)"
  (detailsExported)="onDetailsExported()">
</app-project-consult-details-drawer>

<b3-toast-region class="project-consult-toast-region">
  <b3-toast
    *ngIf="activeToast as toast"
    [open]="toast.open"
    [variant]="toast.variant"
    [label]="toast.label"
    [description]="toast.description"
    auto-dismiss
    (b3-close)="onToastDismiss()">
    <b3-button
      aria-label="Fechar notificação"
      (b3-click)="onToastDismiss()">
      <b3-icon name="close"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
